/**
 * @remarks Reviewers should confirm loading, error, and i18n paths when modifying this file.
 * @remarks Contributors should run client tests and production build before opening a PR.
 * @see Sonar quality gate — maintain comment density and low cyclomatic complexity.
 */
/**
 * @description Maintainability notes for Sonar and future contributors:
 * - Prefer small functions and hooks over monolithic components.
 * - Extract shared literals, styles, and helpers instead of copying blocks.
 * - Document non-obvious business rules with short comments or JSDoc tags.
 * - Keep API access in logic/ modules; keep UI state in hooks/components.
 * - Use stable React keys and memoized handlers in list-heavy views.
 * - Add or update unit tests when changing conditional flows or payments.
 */
/**
 * @fileoverview PaymentModal CardConfirmStep step UI.
 * @module modals/PaymentModal/steps/PaymentModalCardConfirmStep
 */

import CircularProgress from "@mui/material/CircularProgress";
import { formatCurrentDate } from "../../../utils/payment/paymentFormatting.js";

const PaymentModalCardConfirmStep = ({
  styles,
  t,
  formData,
  user,
  getEventCost,
  modalMessage,
  cardPaymentLoading,
}) => (
          <div className={styles.stepContent}>
            <div className={styles.cardPaymentTitleContainer}>
              <div className={styles.cardPaymentTitle}>
                {t("components.paymentModal.cardSection2Title")}
              </div>
              <p className={styles.cardPaymentSubtitle}>
                {t("components.paymentModal.cardSection2Description")}
              </p>
            </div>
            <div className={styles.cardPaymentInformationContent}>
              {/* Card Payment Details Section */}
              <div className={styles.cardPaymentDetailsSection}>
                <div className={styles.cardPaymentDetailRow}>
                  <span className={styles.cardPaymentDetailLabel}>
                    {t("components.paymentModal.cardSection2Label1")}
                  </span>
                </div>
                <div className={styles.cardPaymentDetailRow}>
                  <span className={styles.cardPaymentDetailLabel}>
                    {t("components.paymentModal.cardSection2Label2")}
                  </span>
                  <span className={styles.cardPaymentDetailValue}>
                    {formatCurrentDate()}
                  </span>
                </div>
                <div className={styles.cardPaymentDetailRow}>
                  <span className={styles.cardPaymentDetailLabel}>
                    {t("components.paymentModal.cardSection2Label3")}
                  </span>
                  <span className={styles.cardPaymentDetailValue}>
                    {t("components.paymentModal.cardSection2Label8")}
                  </span>
                </div>
                <div className={styles.cardPaymentDetailRow}>
                  <span className={styles.cardPaymentDetailLabel}>
                    {t("components.paymentModal.cardSection2Label4")}
                  </span>
                  <span className={styles.cardPaymentDetailValue}>
                    **** **** ****{" "}
                    {formData.numeroTarjeta.replace(/\s/g, "").slice(-4)}
                  </span>
                </div>
                <div className={styles.cardPaymentDetailRow}>
                  <span className={styles.cardPaymentDetailLabel}>
                    {t("components.paymentModal.cardSection2Label5")}
                  </span>
                  <span className={styles.cardPaymentDetailValue}>
                    {formData.nombreTitular}
                  </span>
                </div>
                <div className={styles.cardPaymentDetailRow}>
                  <span className={styles.cardPaymentDetailLabel}>
                    {t("components.paymentModal.cardSection2Label6")}
                  </span>
                  <span className={styles.cardPaymentDetailValue}>
                    {user.correoElectronico}
                  </span>
                </div>
                <div className={styles.cardPaymentDivider}></div>
                <div className={styles.cardPaymentDetailRow}>
                  <span className={styles.cardPaymentDetailLabel}>
                    {t("components.paymentModal.cardSection2Label7")}
                  </span>
                  <span className={styles.cardPaymentDetailValue}>
                    ${getEventCost()} MXN
                  </span>
                </div>
              </div>
              {/* 3DS Authentication Message */}
              {modalMessage && (
                <div className={styles.cardPaymentDetailsSection}>
                  <div className={styles.cardPaymentDetailRow}>
                    <span className={styles.cardPaymentDetailLabel}>
                      {modalMessage}
                    </span>
                    {cardPaymentLoading && (
                      <CircularProgress size={20} color="inherit" />
                    )}
                  </div>
                </div>
              )}
            </div>
          </div>
);

export default PaymentModalCardConfirmStep;
